// extracted by mini-css-extract-plugin
export default {"container":"mO85i2ovEwUCGyV3uCuc"};